module.exports = __webpack_public_path__ + "static/pepperland_logo_long-c46e14a22022b55232335cdc02bc4f25.png";